import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { ScoreManager } from '../core/functions/score-manager.service';
import { AuthenticationService } from 'src/app/auth/fire-auth/authentication.service';
import { UserfirestoreService } from 'src/app/auth/fire-store/userfirestore.service';
import { switchMap, takeUntil, map, tap, filter } from 'rxjs/operators';
import { DashboardState } from '../core/state/dashboard.state';
import { User } from 'src/app/auth/models/user';

@Injectable({
  providedIn: 'root',
})
export class DashboardFacade {
  private destroyed$ = new Subject();
  private uid: any;

  constructor(
    private readonly scoreManager: ScoreManager,
    private readonly userService: UserfirestoreService,
    private readonly authenticationService: AuthenticationService,
    private dashboardState: DashboardState
  ) {}

  loadData() {
    this.loadUser();
  }

  loadUser() {
    this.authenticationService
      .getStatus()
      .pipe(
        takeUntil(this.destroyed$),
        switchMap((status) => {
          this.uid = status.uid;
          return this.userService.getUserById(this.uid).valueChanges();
        })
      )
      .subscribe(
        (user: User) => {
          this.dashboardState.setCurrentUser$(user);
          this.dashboardState.setBalance$(user.savings);
          this.loadScore(user);
          this.destroyed$.next();
          this.destroyed$.complete();
        },
        (err) => console.log(err)
      );
  }

  loadScore(user: User) {
    // debugger;
    this.userService
      .getUsers()
      .pipe(
        map((users: User[]) => {
          const similarUsers = users.filter(
            (_user: User) =>
              _user.country === user.country && _user.gender === user.gender
          );
          return similarUsers.map((_user: User) => _user.savings);
        })
      )
      .subscribe(
        (allSavings: number[]) => {
          if (allSavings.length > 1) this.scoreManager.setSavings$(allSavings);
        },
        (error) => console.log(error)
      );
  }

  getScore$(): Observable<number> {
    debugger;
    return this.scoreManager.getScore$();
  }

  getUser$() {
    return this.dashboardState.getCurrentUser$();
  }

  getBalance$() {
    return this.dashboardState.getBalance$();
  }

  setBalance$(balance: number) {
    return this.dashboardState.setBalance$(balance);
  }

  calculateScore(previousUserSavings: number, currentUserSavings: number) {
    this.setBalance$(currentUserSavings);
    this.userService.editUserField(this.uid, { savings: currentUserSavings });

    return this.scoreManager.calculateScore(
      previousUserSavings,
      currentUserSavings
    );
  }
}
